import { useState, useEffect } from "react"

import { useSelector, useDispatch } from "react-redux"
import {
    scheduledPickupColor,
    makeNiceDate,
} from "../helpers"

import { isPartialABusByNamingConvention } from "components/Orders/helpers"
import { setShowReduxModal } from "redux/warehouse/warehouseSlice"
import { PartialLoadConfirmation } from "../modals/LoadConfirmation"
import BlankSpace from "components/UI/Atoms/BlankCell"


export const PartialTypeRowSignal = () => (
    <div className="flex-column">
        <span
            className="badge bg-danger text-white ml-2"
            style={{ fontWeight: "bold" }}>
            P
        </span>
    </div>
)

const PartialRow = ({ partial }) => {
    const dispatch = useDispatch()
    const display = useSelector((state) => state.warehouse.display)
    const warehouse = useSelector((state) => state.warehouse.warehouse)

    return (
        <>
            <tr
                className={`order-row bus-class-${isPartialABusByNamingConvention(partial)}`}
                key={`order-tr-${partial.order.id}`}
            >
                {display === "Incoming" && (
                    <td className="inbound-column">
                        <div style={{ width: '100%' }} className="d-flex justify-content-between">
                            <div className="flex-column">
                                {partial.bus
                                    ? partial.bus.name
                                    : partial.carrier
                                }
                            </div>
                            <div className="flex-column">
                                <PartialTypeRowSignal />
                            </div>
                        </div>
                    </td>
                )}

                {display === "Incoming" && warehouse === "Laredo" && (
                    <td className="trailer-column">{partial.trailer}</td>
                )}
                <td
                    className="dock-column"
                >
                    <BlankSpace />
                </td>
                <td
                    className="order-number-column"
                    style={{ fontWeight: "bold", fontSize: "1.03em" }}
                >
                    {`${partial.order.order_no} ${partial.order.order_group} ${partial.order.pro_f}`}
                </td>
                {display === "Outgoing" && (
                    <td
                        className={`trailer-number-column` + (partial.order.name == 0 ? "cred" : "")}
                    >
                        <div style={{ width: '100%' }} className="d-flex justify-content-between">
                            <div className="flex-column">
                                {partial.bus
                                    ? partial.bus.name
                                    : partial.carrier
                                }
                            </div>
                            <div className="flex-column">
                                <PartialTypeRowSignal />
                            </div>
                        </div>
                    </td>
                )}
                <td
                    className="deliver-to-column"
                    style={{ fontWeight: "bold", fontSize: "1.03em" }}
                >
                    <div>
                        <div style={{ width: '100%' }} className="d-flex justify-content-between">
                            <div className="flex-column">
                                {partial.order.delivery_city_state}
                            </div>
                        </div>

                    </div>
                </td>
                {display === "Outgoing" ? (
                    <td
                        className="scheduled-pickup-column"
                        style={scheduledPickupColor(partial.order.pickup_date)}
                    >
                        {partial.order.pickup_date
                            ? makeNiceDate(partial.order.pickup_date)
                            : ""}
                    </td>
                ) : (
                    <></>
                )}
                <td
                    className="skid-column"
                >
                    {
                        partial.quantity
                            ? <>{`${partial.quantity}/${partial.order.units}`}</>
                            : <><BlankSpace /></>
                    }

                    {display === "Outgoing" ? (
                        partial.order.skid_match_outgoing === true ? (
                            <>
                                <i
                                    className='fa fa-check'
                                    style={{ color: "green" }}
                                />
                            </>
                        ) : partial.order.skid_match_outgoing === false ? (
                            <>
                                <i
                                    className='fa fa-exclamation'
                                    style={{ color: "red" }}
                                />
                            </>
                        ) : (
                            ""
                        )
                    ) : partial.order.skid_match_incoming === true ? (
                        <>
                            <i
                                className='fa fa-check'
                                style={{ color: "green" }}
                            />
                        </>
                    ) : partial.order.skid_match_incoming === false ? (
                        <>
                            <i
                                className='fa fa-exclamation'
                                style={{ color: "red" }}
                            />
                        </>
                    ) : (
                        ""
                    )}
                </td>
                <td
                    className="weight-column"
                >
                    {
                        partial.weight
                        ? <>{partial.weight}</>
                        : <><BlankSpace /></>
                    }
                </td>
                <td
                    className={`actions-column-${display.toLowerCase()}`}
                >
                    <>
                        <button
                            className='btn btn-primary m-1 px-2 py-1'
                            onClick={() => {
                                dispatch(
                                    setShowReduxModal({
                                        partialCreator: {
                                            orderId: partial.order.id,
                                            showModal: true,
                                        },
                                    })
                                );
                            }}
                        >
                            <i className="fa fa-edit"></i>
                        </button>
                        {/* only load by itself if theres no bus */}
                        {!partial.bus ? (
                            <PartialLoadConfirmation partial={partial} />
                        ) :
                            (
                                <>
                                </>
                            )
                        }
                    </>
                </td>
                <td
                    className="notes-column"
                >
                    <input
                        type='text'
                        className='input'
                        style={{
                            minHeight: "36px",
                            minWidth: "100px",
                        }}
                        value={partial.order.notes}
                        disabled={true}
                    />
                </td>
            </tr >
        </>
    )
}

export default PartialRow
